import Header from "./Header";
import { useState, useEffect } from "react";
import { useTranslation } from 'react-i18next';
import { getText } from '../getText';
import { getInformation } from '../getInformation';
import '../css/LandingPage.css'
import Photos from "./Photos";
import ButtonYellow from "./ButtonYellow";
import Footer from "./Footer";

export default function LandingPage() {
    const [text, setText] = useState({})
    const { t, i18n } = useTranslation();
    let lang = i18n.language
    const [information, setInformation] = useState({})
    const [loading, setLoading] = useState(true)

    useEffect(() => {
    Promise.all([getText(), getInformation()]).then(([t, i]) => {
        setText(t)
        setInformation(i)
        setTimeout(() => {setLoading(false)}, 3000)
    })
    }, [])
    if (loading || false) return (<div className='loading_main'><span>B.R.V.</span></div>)
    return (
        <div>
            <Header t={t} i18n={i18n} lang={lang} text={text}></Header>
            <div className="landing_page">
                <div>
                    <h1
                        dangerouslySetInnerHTML={{
                        __html: text?.["title_9"]?.[lang].replace("CUBE 2026", "<br />CUBE 2026<br />")
                        }}
                    />
                    <h2>{text?.["subtitle_9"]?.[lang]}</h2>
                    <div>

                    <ButtonYellow text={text["book_now"][lang]}/>
                    </div>
                </div>
                <div className="about_b_r_v_landing">
                    <h2>{text?.["title_10"]?.[lang]}</h2>
                    <p>{text?.["subtitle_10"]?.[lang]}</p>
                </div>
                <Photos t={t} text={text} lang={lang} />
            </div>
            <Footer information={information} text={text} lang={lang} />
        </div>
    )
}